import React, { useState } from "react";
import {
    Box,
    Button,
    IconButton,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ImagePickerDialog from "../ImagePickerDialog";

const normalizeWords = (words) => (Array.isArray(words) ? words : []).map((word) => String(word || ""));

const QuestionFormFillword = ({ value, onChange }) => {
    const v = value || {};
    const words = normalizeWords(v.correctWords);
    const [pickerOpen, setPickerOpen] = useState(false);

    const setWord = (idx, word) => {
        onChange({
            ...v,
            correctWords: words.map((item, i) => (i === idx ? word : item)),
        });
    };

    const addWord = () => {
        onChange({
            ...v,
            correctWords: [...words, ""],
        });
    };

    const removeWord = (idx) => {
        onChange({
            ...v,
            correctWords: words.filter((_, i) => i !== idx),
        });
    };

    const onPickImage = (img) => {
        onChange({
            ...v,
            imgPath: img.url,
        });
        setPickerOpen(false);
    };

    return (
        <Stack spacing={2}>
            <Typography variant="subtitle2">Філворд</Typography>

            <TextField
                label="Підзаголовок"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                fullWidth
            />

            <TextField
                label="Текст завдання"
                value={v.question || ""}
                onChange={(e) => onChange({ ...v, question: e.target.value })}
                helperText="Наприклад: Знайдіть слова у філворді."
                fullWidth
                multiline
                minRows={3}
            />

            <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }}>
                <TextField
                    label="Зображення філворда"
                    value={v.imgPath || ""}
                    onChange={(e) => onChange({ ...v, imgPath: e.target.value })}
                    fullWidth
                />
                <Button variant="outlined" onClick={() => setPickerOpen(true)} sx={{ minWidth: 180 }}>
                    Вставити зображення
                </Button>
            </Stack>

            {v.imgPath && (
                <Box
                    component="img"
                    src={v.imgPath}
                    alt="Філворд"
                    sx={{
                        width: "100%",
                        maxHeight: 360,
                        objectFit: "contain",
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        backgroundColor: "background.default",
                    }}
                />
            )}

            <Box>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                    <Typography variant="subtitle2" fontWeight={700}>
                        Правильні слова: {words.filter((word) => word.trim()).length}
                    </Typography>
                    <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={addWord}>
                        Додати слово
                    </Button>
                </Stack>

                <Stack spacing={1}>
                    {words.map((word, idx) => (
                        <Stack key={idx} direction="row" spacing={1} alignItems="center">
                            <TextField
                                label={`Слово #${idx + 1}`}
                                value={word}
                                onChange={(e) => setWord(idx, e.target.value)}
                                helperText="Регістр під час проходження не враховується."
                                fullWidth
                            />
                            <IconButton onClick={() => removeWord(idx)} aria-label="Видалити слово">
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    ))}

                    {words.length === 0 && (
                        <Typography variant="body2" color="text.secondary">
                            Додайте слова, які учень має знайти.
                        </Typography>
                    )}
                </Stack>
            </Box>

            <ImagePickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickImage}
            />
        </Stack>
    );
};

export default QuestionFormFillword;
